module.exports = __webpack_public_path__ + "img/soporte.8dbbc7a7.png";